var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row dolu"},[_c('div',{staticClass:"col-12"},[_c('edit-profile-form')],1),_c('div',{staticClass:"col-12"},[_c('members-card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }